import http from './http-common';

class DataService {
  static getByRut(rutdv) {
    const regex = /[^0-9kK]+|[kK](?!\s*$)/g;
    const subst = '';
    const result = rutdv.replace(regex, subst);
    const rut = result.slice(0, -1);
    const dv = result.slice(-1);
    const search = rut.concat('-', dv);
    return http.get(`/person/${search}`);
  }

  static enrolar(data) {
    return http.post('/subscriber', data);
  }
}

export default DataService;
